const ERROR_LIST = {
  unknown: 'ERROR_UNKNOWN',
  allInCart: 'ERROR_ALL_IN_CART',
} as const;

type ErrorList = typeof ERROR_LIST;
type ShopifyAjaxErrorLookup<T extends keyof ErrorList> = ErrorList[T];

export const shopifyAjaxErrorGet = (srcError: any) => {
  let error: keyof ErrorList = 'unknown';

  if (srcError && srcError.description) {
    if (
      srcError.description.startsWith('All') &&
      srcError.description.endsWith('in your cart.')
    ) {
      error = 'allInCart';
    }
  }

  return ERROR_LIST[error] as ShopifyAjaxErrorLookup<typeof error>;
};
